/**
 * User-facing wording for the error codes the Users admin page can receive.
 *
 * In its own module rather than inside UsersPage.tsx because the page is a
 * component file: exporting a constant from it trips
 * react-refresh/only-export-components, and the rule's own advice is to put
 * shared constants in a separate file. Tests import THIS map, so they pin the
 * wording the page actually uses instead of a copy that can drift.
 */
/**
 * T-06 R05 — shown wherever invitations are switched off: on the disabled
 * Invite/Resend controls as a tooltip, and as the toast if the server refuses
 * a click that slipped through (the flag can flip between page load and
 * click). One string, so the button and the error cannot say different things.
 */
export const INVITES_DISABLED_TEXT =
  'Invitations are switched off until the invite-acceptance feature is finished.';

export const USERS_ERROR_MESSAGES: Record<string, string> = {
  NotFound: 'This user no longer exists. The list may be out of date.',
  AuthRequired: 'Your session expired. Please sign in again.',
  PermissionDenied: 'You do not have permission to perform this action.',
  // R02 — two administrators changed the admin set at the same moment and one
  // lost the per-tenant lock. Transient and retryable, so the wording says so
  // rather than reading like a failure.
  AdminGuardBusy: 'Another change to administrators is in progress. Please try again.',
  // R05 — the server refused because invitations are switched off. Same
  // sentence as the disabled controls' tooltip, from the same constant.
  FeatureDisabled: INVITES_DISABLED_TEXT,
  // T-07 (D-27) — the server names the missing permissions in its message;
  // this is only the fallback for a body that carries the bare code.
  DelegationRefused: 'You can only change access for permissions you hold yourself.',
};
